export const GLOBAL_EVENTS = {
    CONNECTION: 'connection',
    CONNECT: 'connect',
    CONNECTED: 'connected',
    CONNECT_ERROR: 'connect_error',
    DISCONNECT: 'disconnect',
    ERROR: 'error',
    UNAUTHORIZED: 'unauthorized',
    JOIN_ROOM: 'JOIN_ROOM',
    LEAVE_ROOM: 'LEAVE_ROOM'
};
export const ANNOUNCEMENT_EVENTS = {
    POST: 'POST_ANNOUNCEMENT',
    EDIT: 'EDIT_ANNOUNCEMENT',
    DELETE: 'DELETE_ANNOUNCEMENT',
    READ: 'READ_ANNOUNCEMENT',
    READ_ALL: 'READ_ALL_ANNOUNCEMENTS'
};
export const LIVESTREAM_EVENTS = {
    UPDATE_SETTINGS: 'UPDATE_SETTINGS',
    UPDATE_POLL: 'UPDATE_POLL',
    PUT_USER: 'PUT_USER',
    VIEW_COUNT: 'VIEW_COUNT'
};
export const PRIVATE_MESSAGE_EVENTS = {
    POST: 'POST_PRIVATE_MESSAGE',
    EDIT: 'EDIT_PRIVATE_MESSAGE',
    DELETE: 'DELETE_PRIVATE_MESSAGE',
    TOGGLE_MOD_CHAT: 'TOGGLE_MOD_CHAT',
    UPDATE_USER: 'UPDATE_USER',
    UPDATE_ALL_USERS: 'UPDATE_ALL_USERS',
    HIGHLIGHT_MESSAGE: 'HIGHLIGHT_MESSAGE'
};
export const PUBLIC_MESSAGE_EVENTS = {
    POST: 'POST_PUBLIC_MESSAGE',
    PUT: 'PUT_PUBLIC_MESSAGE',
    DELETE: 'DELETE_PUBLIC_MESSAGE',
    CLEAR: 'CLEAR_PUBLIC_MESSAGES',
    MARK_AS_QUESTION: 'MARK_AS_QUESTION',
    UNMARK_AS_QUESTION: 'UNMARK_AS_QUESTION',
    UNMARK_ALL_AS_QUESTIONS: 'UNMARK_ALL_AS_QUESTIONS',
    SORT_QUESTION: 'SORT_QUESTION'
};
export const PRODUCT_EVENTS = {
    POST: 'POST_PRODUCT',
    PUT: 'PUT_PRODUCT',
    DELETE: 'DELETE_PRODUCT'
};
export const TRADE_EVENTS = {
    POST: 'POST_TRADE',
    PUT: 'PUT_TRADE',
    DELETE: 'DELETE_TRADE'
};
//# sourceMappingURL=socketEvents.js.map